module.exports = __webpack_public_path__ + "img/org-logo.904c820c.png";